const PassportClient = require('./PassportClient')
const PassportClientError = require('./PassportClientError')
const ErrorCodes = require('./ErrorCodes')
const TokenExpiredError = require('jsonwebtoken').TokenExpiredError

module.exports = options => new PassportClient(options)
module.exports = {
  PassportClient,
  PassportClientError,
  ErrorCodes,
  TokenExpiredError
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chronobank/passport.client/lib/index.js
// module id = tw1q
// module chunks = 0